var Platform;
(function (Platform) {
    var SearchPage;
    (function (SearchPage) {
        function addEntry(control, form, type, entityId, formGroupId, parameters) {
            if (type === void 0) { type = "Dialog"; }
            if (entityId === void 0) { entityId = null; }
            var ctrl = form.control(control);
            entityId = entityId || ctrl.getEntityId();
            if (type === "Dialog") {
                Agitavit.Utilities.openQuickEditDialog(entityId, null, null, null, function () {
                    ctrl.reloadData();
                }, formGroupId, parameters);
            }
            else {
                var url = window.location.protocol + "//" + window.location.host + window.location.pathname + "/Default" + window.location.search;
                if (parameters) {
                    //@ts-ignore
                    url = UrlHelpers.AddQueryParam(url, '__jc', JSON.stringify({ Parameters: parameters }));
                }
                Agitavit.Utilities.openBrowserTab(url);
            }
        }
        SearchPage.addEntry = addEntry;
        function editEntry(control, form, type, entityId, formGroupId, parameters) {
            if (type === void 0) { type = "Dialog"; }
            if (entityId === void 0) { entityId = null; }
            var ctrl = form.control(control);
            entityId = entityId || ctrl.getEntityId();
            var selectedRows = ctrl.getSelectedRows();
            if (selectedRows.length !== 1) {
                return;
            }
            if (type === "Dialog") {
                var selectedRow = selectedRows[0];
                ctrl.clearSelectedRows();
                Agitavit.Utilities.openQuickEditDialog(entityId, selectedRow, null, null, function () {
                    ctrl.reloadData();
                }, formGroupId, parameters);
            }
            else {
                Agitavit.Utilities.openBrowserTab(window.location.protocol + "//" + window.location.host + window.location.pathname + "/Default/" + selectedRows[0] + window.location.search);
            }
        }
        SearchPage.editEntry = editEntry;
        function removeEntries(control, form, entityId) {
            if (entityId === void 0) { entityId = null; }
            var ctrl = form.control(control);
            entityId = entityId || ctrl.getEntityId();
            var selectedRows = ctrl.getSelectedRows();
            Agitavit.Utilities.openDeleteDialog(entityId, selectedRows, function () {
                ctrl.clearSelectedRows();
                ctrl.reloadData();
            });
        }
        SearchPage.removeEntries = removeEntries;
        function toolbarEnableOnSingleSelect(control, form) {
            var buttons = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                buttons[_i - 2] = arguments[_i];
            }
            setTimeout(function () {
                var ctrl = form.control(control);
                var toolbar = form.Toolbar;
                // register on selection change handler
                ctrl.onSelectionChanged.subscribe(function (_, args) {
                    var selectedRows = args.length;
                    buttons.forEach(function (btn) {
                        toolbar.Enable(btn, selectedRows === 1);
                    });
                });
                // set current status
                var selectedRows = ctrl.getSelectedRows().length;
                buttons.forEach(function (btn) {
                    toolbar.Enable(btn, selectedRows === 1);
                });
            });
        }
        SearchPage.toolbarEnableOnSingleSelect = toolbarEnableOnSingleSelect;
        function toolbarEnableOnSelect(control, form) {
            var buttons = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                buttons[_i - 2] = arguments[_i];
            }
            setTimeout(function () {
                var ctrl = form.control(control);
                var toolbar = form.Toolbar;
                // register on selection change handler
                ctrl.onSelectionChanged.subscribe(function (_, args) {
                    var selectedRows = args.length;
                    buttons.forEach(function (btn) {
                        toolbar.Enable(btn, selectedRows >= 1);
                    });
                });
                // set current status
                var selectedRows = ctrl.getSelectedRows().length;
                buttons.forEach(function (btn) {
                    toolbar.Enable(btn, selectedRows >= 1);
                });
            });
        }
        SearchPage.toolbarEnableOnSelect = toolbarEnableOnSelect;
        function editOnDoubleClick(control, form, type, entityId, formGroupId, parameters) {
            if (type === void 0) { type = "Dialog"; }
            if (entityId === void 0) { entityId = null; }
            setTimeout(function () {
                var ctrl = form.control(control);
                ctrl.onDoubleClick.subscribe(function () { return editEntry(control, form, type, entityId, formGroupId, parameters); });
            });
        }
        SearchPage.editOnDoubleClick = editOnDoubleClick;
    })(SearchPage = Platform.SearchPage || (Platform.SearchPage = {}));
})(Platform || (Platform = {}));
//# sourceMappingURL=SearchPage.js.map